import routeMap from "../router_map";

export default {
  path: "/payment",
  meta: {
    title: "全球付款",
    rank: 9
  },
  children: [
    // {
    //   path: "/payment/withdraw",
    //   name: "withDraw",
    //   meta: {
    //     title: "提现",
    //     visible: "0",
    //     operate: "0"
    //   }
    // },
    ...routeMap["/payment/withdraw"],
    // 结汇付款
    {
      path: "/payment/payOut",
      name: "payOut",
      meta: {
        title: "结汇付款",
        visible: "0",
        operate: "0"
      }
    },
    ...routeMap["/payment/payOut"],
    // 国际付款
    {
      path: "/payment/foreign",
      name: "foreign",
      meta: {
        title: "国际付款",
        visible: "0",
        operate: "0"
      }
    },
    ...routeMap["/payment/foreign"],
    {
      path: "/payment/paymentLog",
      name: "paymentLog",
      meta: {
        title: "付款记录",
        visible: "0",
        operate: "0"
      }
    },
    ...routeMap["/payment/paymentLog"]
  ]
};
